import { useCallback, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useSelector } from "react-redux";
import maplibregl from "maplibre-gl";

// import "../Style/main/container.css"

// Icon
import ICON_CLOSE_X_2 from "../Assets/jsx/ICON_CLOSE_X_2";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import icon_compass_v2 from "../Assets/svg/icon_compass_v2.svg";
import logo_kota_jakarta from "../Assets/svg/logo_kota_jakarta.svg";
import logo_dsda from "../Assets/png_jpg/dsda.png";
import logo_export_map from "../Assets/svg/logo_export_map.svg";
import waduk_icon from "../Assets/png_jpg/waduk_situ_embung.png";
import drainase_primer_icon from "../Assets/png_jpg/saluran_drainase_primer.png";
import drainase_sekunder_icon from "../Assets/png_jpg/saluran_drainase_sekunder.png";
import drainase_tersier_icon from "../Assets/png_jpg/saluran_drainase_tersier.png";
import batas_kelurahan from "../Assets/png_jpg/batas_kelurahan.png";
import batas_kabupaten_kota from "../Assets/png_jpg/batas_kabupaten_kota.png";

export default function MODAL_EXPORT_MAP() {
  // Ref Container
  const mainMapRef = useRef(null);
  const insetMapRef = useRef(null);
  const paperContainerRef = useRef(null);
  const canvasRef = useRef(null);
  const insetCanvasRef = useRef(null);

  // Redux State
  const map_object = useSelector((state) => state.layer.map_object);
  const layer = useSelector((state) => state.layer);

  const layer_id = layer.layer_id;
  const layers = map_object?.getStyle()?.layers || [];
  // find layer by id
  const targetLayer = layers.find((l) => l.id === layer_id);

  const [mainMap, setMainMap] = useState(null);
  const [isModal, setIsModal] = useState(false);
  const [compassBearing, setCompassBearing] = useState(0);
  const [graticuleLabel, setGraticuleLabel] = useState({
    main: { x: [], y: [] },
    inset: { x: [], y: [] },
  });

  // eslint-disable-next-line no-unused-vars
  const [dimension, setDimension] = useState({
    main: {
      w: 0,
      h: 0,
    },
    inset: {
      w: 0,
      h: 0,
    },
  });
  const [logoJakartaBase64, setLogoJakartaBase64] = useState(null);
  const [reportTitle, setReportTitle] = useState("");
  const [scale, setScale] = useState(0);
  const [pendingScale, setPendingScale] = useState("");
  const [scaleControl, setScaleControl] = useState({
    width: 0,
    text: "",
  });
  const [dynamicScale, setDynamicScale] = useState({
    width: 0,
    text: "",
    dynamicText: "",
    ticks: [],
  });
  const [legends, setLegends] = useState([]);
  const [isUserInputScale, setIsUserInputScale] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [paperSize, setPaperSize] = useState({
    size: "a4",
    width: 297,
    height: 210,
  });

  const getLayerData = useCallback(() => {
    const { layer_id, geo_layer_list, sorted_by } = layer;
    const geo_layer = geo_layer_list.find(
      (e) => e?.geo_layer?._id === layer_id
    );
    const style =
      geo_layer?.geo_layer?.style_array[0]?.paint_object["circle-color"];
    let selectedStyle = [];

    // pastikan style adalah array dan punya panjang cukup
    if (Array.isArray(style) && style.length > 3) {
      for (let i = 2; i < style.length - 1; i += 2) {
        selectedStyle.push([style[i], style[i + 1]]);
      }
    }

    // for(let i = 2; i < style.length - 1; i+=2){
    //     selectedStyle.push([style[i],style[i+1]])
    // }

    setLegends(selectedStyle);

    if (!geo_layer?.geo_layer) return;
    let fields_layer = geo_layer.geo_layer.fields || [];
    fields_layer = fields_layer.filter(
      (d) =>
        ![
          "icon_image",
          "text_field",
          "fill_color",
          "circle_radius",
          "circle_stroke_width",
          "circle_stroke_color",
          "is_using_icon",
          "is_using_label",
        ].includes(d.key)
    );
    let features_filtered =
      geo_layer.geo_layer.geojson_filtered?.features || [];
    let field, sort;
    if (sorted_by?.length > 0) {
      field = sorted_by?.[0]?.field;
      sort = sorted_by?.[0]?.sort;

      const isFromSmall = sort === "desc" ? false : true;
      const key = field;
      features_filtered = features_filtered.sort((a, b) => {
        if (a?.properties?.[key] < b?.properties?.[key]) {
          return isFromSmall ? -1 : 1;
        }
        if (a?.properties?.[key] > b?.properties?.[key]) {
          return isFromSmall ? 1 : -1;
        }
        return 0;
      });
    }

    const fields = fields_layer;
    const key = fields.map((d) => d.key);

    const latLongKeys = fields
      .filter((field) => ["latitude", "longitude"].includes(field.name))
      .map((field) => field.key);

    const newData = features_filtered.map((d, index) => {
      let obj = {};
      key.forEach((element) => {
        let value = "";
        if (d.properties?.[element] !== undefined) {
          if (latLongKeys.includes(element)) {
            // menentukan digit desimal pada latitude dan longitude
            const newValue = d.properties[element];
            value = String(newValue.toFixed(5));
          } else {
            value = String(d.properties[element]);
          }
        } else if (d.child_array?.[0]?.properties?.[element] !== undefined) {
          value = String(d.child_array[0].properties[element]);
        }
        obj[element] = value;
      });
      return { ...obj, no: index + 1 };
    });

    const eventDateField = fields.find(
      (field) => field.name === "Tanggal Kejadian"
    );
    if (!eventDateField) {
      // console.warn("Field 'Tanggal Kejadian' tidak ditemukan dalam fields_layer:", fields);
      return; // keluar dulu supaya tidak lanjut pakai undefined
    }
    const eventDateKey = fields.find(
      (field) => field.name === "Tanggal Kejadian"
    ).key;
    const eventDates = [...new Set(newData.map((data) => data[eventDateKey]))];
    const sortedDates = eventDates.sort();
    const startDate = new Date(sortedDates[0])?.toLocaleString("id-ID", {
      month: "short",
      day: "2-digit",
    });
    const endDate = new Date(
      sortedDates[sortedDates.length - 1]
    )?.toLocaleString("id-ID", { month: "short", day: "2-digit" });
    const year = new Date(sortedDates[0])?.toLocaleString("id-ID", {
      year: "numeric",
    });
    setReportTitle(
      `SEBARAN GENANGAN ${startDate.toUpperCase()} - ${endDate.toUpperCase()} ${year}`
    );
  }, [layer]);

  const generateGraticuleLabel = (labels = [], position, mapType = "main") => {
    if (!labels.length) return;

    const generateTopStyle = (index) => {
      return {
        tick: {
          position: "absolute",
          left: `${((index + 1) / (labels.length + 1)) * 100}%`,
          height: "1rem",
          top: "-0.5rem",
          borderLeft: "1px solid black",
        },
        label: {
          position: "absolute",
          top: mapType === "main" ? "-1rem" : "-.75rem",
          left: "50%",
          transform: "translateX(-50%)",
          whiteSpace: "nowrap",
        },
      };
    };

    const generateBottomStyle = (index) => {
      return {
        tick: {
          position: "absolute",
          bottom: "-0.5rem",
          left: `${((index + 1) / (labels?.length + 1)) * 100}%`,
          borderLeft: "1px solid black",
          height: ".5rem",
        },
        label: {
          position: "absolute",
          bottom: mapType === "main" ? "-1rem" : "-.75rem",
          left: "50%",
          transform: "translateX(-50%)",
          whiteSpace: "nowrap",
        },
      };
    };

    const generateLeftStyle = (index) => {
      return {
        tick: {
          position: "absolute",
          left: "-.5rem",
          top: `${((index + 1) / (labels?.length + 1)) * 100}%`,
          borderBottom: "1px solid black",
          width: ".5rem",
        },
        label: {
          position: "absolute",
          transformOrigin: "center center",
          top: "50%",
          left: "-100%",
          transform: "translateY(-50%) translateX(-50%) rotate(-90deg)",
          zIndex: 30,
        },
      };
    };

    const generateRightStyle = (index) => {
      return {
        tick: {
          position: "absolute",
          right: "-.5rem",
          top: `${((index + 1) / (labels?.length + 1)) * 100}%`,
          borderBottom: "1px solid black",
          width: ".5rem",
        },
        label: {
          position: "absolute",
          transformOrigin: "center center",
          top: "50%",
          right: "-120%",
          transform: "translateY(-50%) translateX(50%) rotate(-90deg)",
          zIndex: 30,
        },
      };
    };

    return (
      <>
        {labels.map((label, index) => {
          if (mapType === "inset") {
            return (
              <div
                key={index}
                style={
                  position === "top"
                    ? generateTopStyle(index).tick
                    : position === "bottom"
                    ? generateBottomStyle(index).tick
                    : position === "left"
                    ? generateLeftStyle(index).tick
                    : position === "right"
                    ? generateRightStyle(index).tick
                    : {}
                }
              >
                {index % 2 !== 0 ? (
                  <div />
                ) : (
                  <div
                    style={
                      position === "top"
                        ? generateTopStyle(index).label
                        : position === "bottom"
                        ? generateBottomStyle(index).label
                        : position === "left"
                        ? generateLeftStyle(index).label
                        : position === "right"
                        ? generateRightStyle(index).label
                        : {}
                    }
                    className={
                      mapType === "main"
                        ? "dsda-main-map-graticule-label"
                        : mapType === "inset"
                        ? "dsda-inset-map-graticule-label"
                        : ""
                    }
                  >
                    {label}
                  </div>
                )}
              </div>
            );
          } else if (mapType === "main") {
            return (
              <div
                key={index}
                style={
                  position === "top"
                    ? generateTopStyle(index).tick
                    : position === "bottom"
                    ? generateBottomStyle(index).tick
                    : position === "left"
                    ? generateLeftStyle(index).tick
                    : position === "right"
                    ? generateRightStyle(index).tick
                    : {}
                }
              >
                <div
                  style={
                    position === "top"
                      ? generateTopStyle(index).label
                      : position === "bottom"
                      ? generateBottomStyle(index).label
                      : position === "left"
                      ? generateLeftStyle(index).label
                      : position === "right"
                      ? generateRightStyle(index).label
                      : {}
                  }
                  className={
                    mapType === "main"
                      ? "dsda-main-map-graticule-label"
                      : mapType === "inset"
                      ? "dsda-inset-map-graticule-label"
                      : ""
                  }
                >
                  {label}
                </div>
              </div>
            );
          }

          return null;
        })}
      </>
    );
  };

  // Convert Decimal Number to Degree Minute Second (DMS) Format
  const decimalToDMS = (coord, type) => {
    const absolute = Math.abs(coord);
    const degrees = Math.floor(absolute);
    const minutesNotTruncated = (absolute - degrees) * 60;
    const minutes = Math.floor(minutesNotTruncated);
    const seconds = Math.floor((minutesNotTruncated - minutes) * 60);

    let direction = "";
    if (type === "lat") {
      direction = coord >= 0 ? "N" : "S";
    } else if (type === "lng") {
      direction = coord >= 0 ? "E" : "W";
    }

    return `${degrees}°${minutes}'${seconds}"${direction}`;
  };

  const updateBoundingBox = useCallback(
    (mapObject, numRows, numCols, whichMap) => {
      if (!mapObject) return;

      const bounds = mapObject.getBounds();
      const north = bounds.getNorth();
      const south = bounds.getSouth();
      const west = bounds.getWest();
      const east = bounds.getEast();

      // step untuk longitude (bagi sisi atas/bawah)
      const stepLng = (east - west) / (numCols + 1);

      // step untuk latitude (bagi sisi kiri/kanan)
      const stepLat = (north - south) / (numRows + 1);

      const xLabels = [];
      const yLabels = [];

      // label longitude (bujur)
      for (let i = 0; i < numCols; i++) {
        const lng = west + stepLng * (i + 1);
        xLabels.push(decimalToDMS(lng, "lng"));
      }

      // label latitude (lintang)
      for (let i = 0; i < numRows; i++) {
        const lat = north - stepLat * (i + 1);
        yLabels.push(decimalToDMS(lat, "lat"));
      }

      if (whichMap === "main") {
        setGraticuleLabel((prev) => ({
          ...prev,
          main: { x: xLabels, y: yLabels },
        }));
      } else if (whichMap === "inset") {
        setGraticuleLabel((prev) => ({
          ...prev,
          inset: { x: xLabels, y: yLabels },
        }));
      }
    },
    []
  );

  const handleExportPDF = async () => {
    if (!paperContainerRef.current) return;
    const navControl = mainMap
      ?.getContainer()
      .querySelector(".maplibregl-ctrl-top-right");
    try {
      if (navControl) {
        navControl.style.display = "none";
      }
      const pdf = new jsPDF("landscape", "mm", paperSize.size);

      const canvas = await html2canvas(paperContainerRef.current, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: "#ffffff",
      });

      const imgData = canvas.toDataURL("image/png");

      pdf.addImage(imgData, "PNG", 0, 0, paperSize.width, paperSize.height);

      pdf.save("map-export.pdf");
    } catch (error) {
      console.error("Error exporting to PDF: ", error);
    } finally {
      if (navControl) {
        navControl.style.display = "block";
      }
    }
  };

  // convert logo jakarta to base64
  const convertLogoToBase64 = async (img) => {
    try {
      const res = await fetch(img);
      if (!res.ok) {
        throw new Error(`Gagal memuat logo: ${res.status} ${res.statusText}`);
      }
      const blob = await res.blob();
      const reader = new FileReader();

      const dataUrl = await new Promise((resolve, reject) => {
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(blob);
      });
      setLogoJakartaBase64(dataUrl);
    } catch (error) {
      console.error("Error saat memuat logo: ", error);
    }
  };

  const generateMapScale = (map, dpi) => {
    if (!map) return;
    const lat = map.getCenter().lat;
    const zoom = map.getZoom();
    const C = 40075016.686; // keliling bumi di ekuator (meter)
    const TILE = 512;
    const metersPerPixel =
      (Math.cos((lat * Math.PI) / 180) * C) / (TILE * Math.pow(2, zoom));
    return Math.round(
      (metersPerPixel * (dpi * (window.devicePixelRatio || 1))) / 0.0254
    ); // 96 DPI, 1 inci = 0.0254 m
  };

  const generateScaleToZoom = (map, scaleRatio, dpi = 96) => {
    if (!map || scaleRatio <= 0) return NaN;
    const lat = map.getCenter().lat;
    const C = 40075016.686; // keliling bumi di ekuator (meter)

    // Konversi rasio skala (1:N) -> meters per Inch = N
    const metersPerInch = scaleRatio;
    const metersPerPixel =
      (metersPerInch * 0.0254) / (dpi * (window.devicePixelRatio || 1));

    // Hitung zoom dari metersPerPixel
    const cosLat = Math.cos((lat * Math.PI) / 180);
    const numerator = cosLat * C;
    const denominator = 512 * metersPerPixel;

    if (denominator <= 0 || numerator <= 0) return NaN;
    const zoom = Math.log2(numerator / denominator);

    // Batasi zoom sesuai Maplibre (0-24 umumnya)
    return Math.min(Math.max(zoom, 0), 24);
  };

  // eslint-disable-next-line no-unused-vars
  useEffect(() => {
    const controller = new AbortController();
    // eslint-disable-next-line no-unused-vars
    convertLogoToBase64(logo_kota_jakarta, controller.signal);
    // eslint-disable-next-line no-unused-vars
    getLayerData();
    // eslint-disable-next-line no-unused-vars

    return () => {
      controller.abort();
    };
  }, [layer, getLayerData]);

  // Get main map
  useEffect(() => {
    if (!isModal) return;
    if (!mainMapRef.current || !insetMapRef.current || !map_object) return;

    const center = map_object.getCenter();
    const zoom = map_object.getZoom();
    const bearing = map_object.getBearing();
    const pitch = map_object.getPitch();
    const style = map_object.getStyle();

    // Membuat Main Map
    const newMainMap = new maplibregl.Map({
      container: mainMapRef.current,
      // style,
      style:
        "https://dsda-jakarta.s3.ap-southeast-3.amazonaws.com/style-map-dsda.json",
      center,
      zoom,
      bearing,
      pitch,
      interactive: true,
      attributionControl: false,
      canvasContextAttributes: { preserveDrawingBuffer: true, antialias: true },
    });
    setMainMap(newMainMap);

    // clone deep biar nggak nyentuh objek aslinya
    const insetStyle = JSON.parse(JSON.stringify(style));

    // sembunyikan layer tipe point (circle/symbol/heatmap) di inset
    insetStyle.layers = insetStyle.layers = insetStyle.layers.map((l) => {
      if (["circle"].includes(l.type)) {
        return {
          ...l,
          layout: { ...(l.layout || {}), visibility: "none" },
        };
      }
      return l; // ✅ Tambahkan ini jika belum ada
    });

    // Membuat Inset Map
    const newInsetMap = new maplibregl.Map({
      container: insetMapRef.current,
      style: insetStyle,
      center,
      zoom: Math.max(0, newMainMap.getZoom() - 5),
      bearing,
      pitch,
      interactive: false,
      attributionControl: false,
      canvasContextAttributes: { preserveDrawingBuffer: true, antialias: true },
    });

    // scale control
    const scaleControl = new maplibregl.ScaleControl({
      maxWidth: 200,
      unit: "metric",
    });

    newMainMap.addControl(new maplibregl.NavigationControl(), "top-right");
    newMainMap.addControl(scaleControl);

    // 2) Helper untuk size & DPI
    const resizeCanvasToMap = () => {
      const canvas = canvasRef.current;
      const container = newMainMap.getContainer();
      if (!canvas || !container) return;

      const w = container.clientWidth;
      const h = container.clientHeight;
      const dpr = window.devicePixelRatio || 1;

      // set ukuran internal & CSS agar tajam di HiDPI
      canvas.width = Math.max(1, Math.floor(w * dpr));
      canvas.height = Math.max(1, Math.floor(h * dpr));
      canvas.style.width = `${w}px`;
      canvas.style.height = `${h}px`;
    };

    const resizeInsetCanvasToMap = () => {
      const canvas = insetCanvasRef.current;
      const container = newInsetMap.getContainer();
      if (!canvas || !container) return;

      const w = container.clientWidth;
      const h = container.clientHeight;
      const dpr = window.devicePixelRatio || 1;

      canvas.width = Math.max(1, Math.floor(w * dpr));
      canvas.height = Math.max(1, Math.floor(h * dpr));
      canvas.style.width = `${w}px`;
      canvas.style.height = `${h}px`;
    };

    const drawCanvasOverlay = () => {
      // Overlay pada main map
      const canvas = canvasRef.current;
      if (!canvas) return;
      const ctx = canvas.getContext("2d");
      if (!ctx) return;

      const dpr = window.devicePixelRatio || 1;
      // reset transform lalu scale sesuai DPR
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.scale(dpr, dpr);

      // hitung ukuran dalam pixel CSS (bukan internal pixel)
      const w = parseFloat(canvas.style.width) || canvas.width / dpr;
      const h = parseFloat(canvas.style.height) || canvas.height / dpr;

      // Membuat crosshair graticule
      const numSegments = 5;

      let plusSize = 4;
      ctx.strokeStyle = "#000000";
      ctx.lineWidth = 0.5;

      ctx.setLineDash([]);
      for (let i = 1; i < numSegments; i++) {
        const x = (i * w) / numSegments;
        for (let j = 1; j < numSegments; j++) {
          const y = (j * h) / numSegments;
          // intersectPoints.push({x,y})
          ctx.beginPath();
          // Garis horizontal: dari kiri ke kanan
          ctx.moveTo(x - plusSize, y);
          ctx.lineTo(x + plusSize, y);

          ctx.moveTo(x, y - plusSize);
          ctx.lineTo(x, y + plusSize);
          ctx.stroke();
        }
      }

      // Overlay pada inset map
      const insetCanvas = insetCanvasRef.current;
      if (!insetCanvas) return;
      const insetCtx = insetCanvas.getContext("2d");
      if (!insetCtx) return;

      insetCtx.setTransform(1, 0, 0, 1, 0, 0);
      insetCtx.scale(dpr, dpr);

      insetCtx.strokeStyle = "#bfffe9";
      insetCtx.lineWidth = 0.5;

      const insetW =
        parseFloat(insetCanvas.style.width) || insetCanvas.width / dpr;
      const insetH =
        parseFloat(insetCanvas.style.height) || insetCanvas.height / dpr;

      const cols = 5;
      const rows = 4;

      const stepX = insetW / cols;
      const stepY = insetH / rows;

      insetCtx.save();
      insetCtx.beginPath();

      for (let i = 1; i < cols; i++) {
        const x = i * stepX;
        insetCtx.moveTo(x, 0);
        insetCtx.lineTo(x, insetH);
      }

      for (let i = 1; i < rows; i++) {
        const y = i * stepY;
        insetCtx.moveTo(0, y);
        insetCtx.lineTo(insetW, y);
      }

      insetCtx.stroke();
      insetCtx.restore();

      // highlight main viewport pada inset
      // ukuran visual canvas inset (css px)

      const mainW = newMainMap.getContainer().clientWidth;
      const mainH = newMainMap.getContainer().clientHeight;

      const TL = newMainMap.unproject([0, 0]);
      const TR = newMainMap.unproject([mainW, 0]);
      const BR = newMainMap.unproject([mainW, mainH]);
      const BL = newMainMap.unproject([0, mainH]);

      // Proyeksikan sudut-sudut itu ke piksel di inset map
      const pTL = newInsetMap.project(TL);
      const pTR = newInsetMap.project(TR);
      const pBR = newInsetMap.project(BR);
      const pBL = newInsetMap.project(BL);

      insetCtx.lineWidth = 1.5;
      insetCtx.strokeStyle = "#f33300"; // merah outline
      insetCtx.fillStyle = "rgba(14,165,233,0.18)"; // isi transparan

      insetCtx.beginPath();
      insetCtx.moveTo(pTL.x, pTL.y);
      insetCtx.lineTo(pTR.x, pTR.y);
      insetCtx.lineTo(pBR.x, pBR.y);
      insetCtx.lineTo(pBL.x, pBL.y);
      insetCtx.closePath();
      insetCtx.fill();
      insetCtx.stroke();

      insetCtx.restore();
    };

    const redraw = () => {
      // 1. Dapatkan ukuran container peta utama
      const mainMapContainer = newMainMap.getContainer();
      const insetMapContainer = newInsetMap.getContainer();
      if (mainMapContainer && insetMapContainer) {
        const wMainMap = mainMapContainer.clientWidth;
        const hMainMap = mainMapContainer.clientHeight;

        const wInsetMap = insetMapContainer.clientWidth;
        const hInsetMap = insetMapContainer.clientHeight;

        // 2. Simpan ke state dimension.main
        setDimension((prev) => ({
          ...prev,
          main: { wMainMap, hMainMap },
          inset: { wInsetMap, hInsetMap },
        }));
      }

      setCompassBearing(newMainMap.getBearing());

      const scaleControlElement = scaleControl._container;
      setTimeout(() => {
        if (scaleControlElement) {
          scaleControlElement.style.opacity = "0";
          scaleControlElement.style.pointerEvents = "none";
        }
      }, 0);
      setScaleControl((prev) => ({
        ...prev,
        width: scaleControlElement?.offsetWidth,
        text: scaleControlElement?.textContent?.trim(),
      }));

      newInsetMap.jumpTo({
        center: newMainMap.getCenter(),
        bearing: newMainMap.getBearing(),
        pitch: newMainMap.getPitch(),
        zoom: Math.max(0, newMainMap.getZoom() - 5),
      });
      resizeCanvasToMap();
      resizeInsetCanvasToMap();
      // (opsional) refresh label graticule
      setGraticuleLabel({ main: { x: [], y: [] }, inset: { x: [], y: [] } });
      updateBoundingBox(newMainMap, 4, 4, "main");
      updateBoundingBox(newInsetMap, 3, 4, "inset");
      drawCanvasOverlay();
    };

    const handleMoveEnd = () => {
      setIsUserInputScale(false);
    };

    newMainMap.on("load", () => {
      // 1b) Pastikan canvas overlay berada paling akhir di dalam container map
      // agar selalu di atas, selain z-index

      // 1. Tambahkan source GeoJSON
      // SALURAN DRAINASE PRIMER
      // newMainMap.addSource("drainase-primer-source", {
      //     type: "geojson",
      //     data: "https://dsda-jakarta.s3.ap-southeast-3.amazonaws.com/SALURAN_PRIMER_MULTILINE.geojson"
      // });
      // newMainMap.addLayer({
      //     id: "dsda-drainase-primer",
      //     type: "line",
      //     source: "drainase-primer-source", // ✅ ini harus match dengan id di addSource
      //     paint: {
      //     "line-color": "#1160d6",
      //     "line-width": 2,
      //     }
      // }, "place_village");

      // // SALURAN DRAINASE SEKUNDER
      // newMainMap.addSource("drainase-sekunder-source", {
      //     type: "geojson",
      //     data: "https://dsda-jakarta.s3.ap-southeast-3.amazonaws.com/SALURAN_SEKUNDER_MULTILINE.geojson"
      // });
      // newMainMap.addLayer({
      //     id: "dsda-drainase-sekunder",
      //     type: "line",
      //     source: "drainase-sekunder-source", // ✅ ini harus match dengan id di addSource
      //     paint: {
      //     "line-color": "#0098eb",
      //     "line-width": 2,
      //     }
      // }, "place_village");

      // // SALURAN DRAINASE TERSIER
      // newMainMap.addSource("drainase-tersier-source", {
      //     type: "geojson",
      //     data: "https://dsda-jakarta.s3.ap-southeast-3.amazonaws.com/SALURAN_TERSIER.geojson"
      // });
      // newMainMap.addLayer({
      //     id: "dsda-drainase-tersier",
      //     type: "line",
      //     source: "drainase-tersier-source", // ✅ ini harus match dengan id di addSource
      //     paint: {
      //     "line-color": "#72daf7",
      //     "line-width": 2,
      //     }
      // }, "place_village");

      // // BATAS KELURAHAN
      // newMainMap.addSource("batas-kelurahan-source", {
      //     type: "geojson",
      //     data: "https://dsda-jakarta.s3.ap-southeast-3.amazonaws.com/DESA_ADM_JAKARTA_MULTILINE.geojson"
      // });
      // newMainMap.addLayer({
      //     id: "dsda-batas-kelurahan",
      //     type: "line",
      //     source: "batas-kelurahan-source", // ✅ ini harus match dengan id di addSource
      //     paint: {
      //     "line-color": "#000000",
      //     "line-width": 2,
      //     "line-dasharray": [1, 5, 6 , 5]
      //     }
      // }, "place_village");

      // // BATAS KOTA/KABUPATEN
      // newMainMap.addSource("batas-kota-kabupaten-source", {
      //     type: "geojson",
      //     data: "https://dsda-jakarta.s3.ap-southeast-3.amazonaws.com/KABKOT_ADM_JAKARTA_MULTILINE.geojson"
      // });
      // newMainMap.addLayer({
      //     id: "dsda-batas-kota-kabupaten",
      //     type: "line",
      //     source: "batas-kota-kabupaten-source", // ✅ ini harus match dengan id di addSource
      //     paint: {
      //     "line-color": "#949494",
      //     "line-width": 2,
      //     }
      // }, "place_village");

      // // WADUK
      // newMainMap.addSource("waduk-source", {
      //     type: "geojson",
      //     data: "https://dsda-jakarta.s3.ap-southeast-3.amazonaws.com/WADUK-POLYGON.geojson"
      // });
      // newMainMap.addLayer({
      //     id: "dsda-waduk-fill",
      //     type: "fill",
      //     source: "waduk-source", // ✅ ini harus match dengan id di addSource
      //     paint: {
      //     "fill-color": "#95d7f0",
      //     }
      // }, "place_village");
      // newMainMap.addLayer({
      //     id: "dsda-waduk-outline",
      //     type: "line",
      //     source: "waduk-source", // ✅ ini harus match dengan id di addSource
      //     paint: {
      //     "line-color": "#2152cf",
      //     "line-width": 3
      //     }
      // }, "place_village")

      // newMainMap.getStyle().layers.forEach(layer => {
      //     if(layer.type === "circle"){
      //         newMainMap.moveLayer(layer.id)
      //     }
      // })

      // cari geojson di layer geo_layer_list dengan layer_id
      const flood_layer = layer.geo_layer_list.find(
        (l) => l?.geo_layer?._id === layer_id
      );
      if (flood_layer) {
        newMainMap.addSource(layer_id, {
          type: "geojson",
          data:
            flood_layer?.geo_layer?.geojson_filtered ||
            flood_layer?.geo_layer?.geojson,
        });
        newMainMap.addLayer(targetLayer);
      }

      const canvas = canvasRef.current;
      if (canvas) {
        newMainMap.getContainer().appendChild(canvas);
      }
      const initialScale = generateMapScale(newMainMap, 96);
      if (initialScale && !isNaN(initialScale)) {
        setScale(initialScale);
      }
      redraw();
    });

    // 4) Redraw saat render & resize & move
    newMainMap.on("render", () => {
      drawCanvasOverlay();
      redraw();
    });

    newMainMap.on("zoom", () => {
      if (!isUserInputScale) {
        const newScale = generateMapScale(newMainMap, 96);
        if (newScale && !isNaN(newScale)) {
          setScale(newScale);
        }
      }
    });
    newMainMap.on("resize", redraw);

    newMainMap.on("moveend", handleMoveEnd);

    return () => {
      newMainMap.off("moveend", handleMoveEnd);
      newMainMap.remove();
      newInsetMap.remove();
    };
    // eslint-disable-next-line
  }, [isModal, map_object, isUserInputScale, updateBoundingBox]);

  useEffect(() => {
    if (isModal) setPendingScale(scale ? String(scale) : "");
  }, [isModal, scale]);

  const INCH_TO_M = 0.0254;
  const DPI = 96 * (window.devicePixelRatio || 1);
  const BAR_PX = 200;
  // const MIN_PX = 100, MAX_PX = 200, TARGET_PX = (MIN_PX + MAX_PX) / 2

  const CANDIDATES_M = [
    3, 5, 10, 20, 30, 50, 100, 200, 300, 500, 1000, 2000, 3000, 5000, 10000,
    20000, 30000, 50000, 100000, 200000, 300000, 500000, 1000000, 2000000,
    3000000, 5000000, 10000000,
  ];
  const MIN_M = CANDIDATES_M[0];
  const MAX_M = CANDIDATES_M[CANDIDATES_M.length - 1];

  const mppFromScale = useCallback(
    (n) => {
      return (n * INCH_TO_M) / DPI;
    },
    [DPI]
  );

  const clamp = (x, a, b) => {
    return Math.min(Math.max(x, a), b);
  };

  const getTopUnit = (m) => (m >= 1000 ? "km" : "m");
  const formatInUnit = (m, unit, maxMeters) => {
    if (unit === "km") {
      const km = m / 1000;
      const dec = maxMeters / 1000 < 5 ? 1 : 0;
      const s = km.toFixed(dec);
      return `${s.endsWith(".0") ? parseInt(s) : s} km`;
    } else {
      const dec = maxMeters < 10 ? 1 : 0;
      const s = m.toFixed(dec);
      return `${s.endsWith(".0") ? parseInt(s) : s} m`;
    }
  };

  // eslint-disable-next-line no-unused-vars
  const computeFixedBarLabel = useCallback(
    (n) => {
      const mpp = mppFromScale(n);
      const worldMeters = BAR_PX * mpp;
      const clamped = clamp(worldMeters, MIN_M, MAX_M);
      const outOfRange = worldMeters !== clamped;
      const prefix = outOfRange ? (worldMeters < MIN_M ? "< " : "> ") : "";

      const numPoints = 4;
      const step = clamped / (numPoints - 1);
      const ticks = Array.from({ length: numPoints }, (_, i) => i * step);

      // pilih satuan dari nilai maksimum
      const unit = getTopUnit(clamped);

      // label utama dan semua ticks pakai satuan yang sama
      const dynamicText = prefix + formatInUnit(clamped, unit, clamped);
      const tickLabels = ticks.map((d) => formatInUnit(d, unit, clamped));
      setDynamicScale({
        width: scaleControl.width,
        text: clamped,
        dynamicText,
        ticks: tickLabels,
      });
    },
    [scaleControl.width, MAX_M, MIN_M, mppFromScale]
  );

  useEffect(() => {
    computeFixedBarLabel(scale);
  }, [scale, computeFixedBarLabel]);

  return (
    <>
      {isModal ? (
        createPortal(
          <div
            style={{
              position: "fixed",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              top: "0",
              right: "0",
              bottom: "0",
              left: "0",
              backgroundColor: "#05050580",
              zIndex: 10,
            }}
          >
            {/* Modal Container */}
            <div
              style={{
                position: "relative",
                height: "95vh",
                aspectRatio: "297/210",
                backgroundColor: "#ffffff",
                borderRadius: ".75rem",
                boxSizing: "border-box",
                padding: "3rem",
              }}
            >
              {/* Map Container */}
              <div
                ref={paperContainerRef}
                style={{
                  width: "100%",
                  height: "100%",
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "row",
                  border: "1px solid grey",
                  padding: "1rem",
                }}
              >
                {/* Main Map Section */}
                <section
                  style={{
                    height: "100%",
                    aspectRatio: "1/1",
                    // backgroundColor: "lightblue",
                    padding: "1rem",
                    boxSizing: "border-box",
                  }}
                >
                  {/* Main Map */}
                  <div
                    style={{
                      border: "1px solid black",
                      width: "100%",
                      height: "100%",
                      position: "relative",
                    }}
                  >
                    {generateGraticuleLabel(
                      graticuleLabel.main.x,
                      "top",
                      "main"
                    )}
                    {generateGraticuleLabel(
                      graticuleLabel.main.x,
                      "bottom",
                      "main"
                    )}
                    {generateGraticuleLabel(
                      graticuleLabel.main.y,
                      "left",
                      "main"
                    )}
                    {generateGraticuleLabel(
                      graticuleLabel.main.y,
                      "right",
                      "main"
                    )}
                    <div
                      ref={mainMapRef}
                      style={{
                        width: "100%",
                        height: "100%",
                        position: "relative",
                      }}
                    >
                      <canvas
                        ref={canvasRef}
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          pointerEvents: "none",
                          zIndex: 10,
                        }}
                      />
                    </div>
                  </div>
                </section>

                {/* Metadata Map Section */}
                <section
                  style={{
                    height: "100%",
                    width: "100%",
                    marginLeft: "1rem",
                    padding: "1rem 0",
                    boxSizing: "border-box",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "1px solid black",
                    }}
                  >
                    {/* BOX 1 */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        borderBottom: "1px solid black",
                        alignItems: "center",
                        boxSizing: "border-box",
                        padding: "5px 0",
                      }}
                    >
                      <img
                        src={logoJakartaBase64}
                        style={{
                          width: "2rem",
                        }}
                        alt="logo kota jakarta"
                      />
                      <span className="dsda-meta-dki-title">
                        PEMERINTAH PROVINSI
                      </span>
                      <span className="dsda-meta-dki-title">
                        DAERAH KHUSUS IBUKOTA JAKARTA
                      </span>
                    </div>

                    {/* BOX 2 */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        borderBottom: "1px solid black",
                        alignItems: "center",
                        boxSizing: "border-box",
                        padding: "5px 0",
                      }}
                    >
                      <img
                        src={logo_dsda}
                        style={{
                          width: "5rem",
                        }}
                        alt="logo dsda"
                      />
                      <span className="dsda-meta-pusdatin-title">
                        DINAS SUMBER DAYA AIR
                      </span>
                    </div>

                    {/* BOX 3 */}
                    <div className="dsda-meta-layer-title-container">
                      <span className="dsda-meta-layer-title">
                        {reportTitle}
                      </span>
                      <span className="dsda-meta-layer-title">
                        DINAS SUMBER DAYA AIR PROVINSI DKI JAKARTA
                      </span>
                    </div>

                    {/* BOX 4 */}
                    <div className="dsda-meta-skala-container">
                      {/* Compass */}
                      <div
                        style={{
                          height: "100%",
                          // marginLeft: "3rem",
                        }}
                      >
                        <img
                          src={icon_compass_v2}
                          alt=""
                          style={{
                            transform: `rotate(${-compassBearing}deg)`,
                          }}
                          className="dsda-compass"
                        />
                      </div>

                      {/* Scale */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: ".5rem",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            fontSize: ".75rem",
                            width: "fit-content",
                          }}
                        >
                          <span className="dsda-meta-skala">SKALA</span>
                          <span className="dsda-meta-skala">
                            1 : {`${scale?.toLocaleString("id-ID")}`}
                          </span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            gap: "5px",
                            marginTop: ".5rem",
                            width: "fit-content",
                          }}
                        >
                          <div
                            style={{
                              // width: `${scaleControl.width}px`,
                              width: "200px",
                              height: ".75rem",
                              backgroundColor: "#84cbfa30",
                              border: "1px solid black",
                              position: "relative",
                            }}
                          >
                            {(() => {
                              const N = Math.max(
                                1,
                                (dynamicScale.ticks?.length || 1) - 1
                              );
                              return (
                                <div
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns: `repeat(${N}, 1fr)`,
                                    height: "100%",
                                  }}
                                >
                                  {Array.from({ length: N }).map((_, i) => (
                                    <div
                                      key={i}
                                      style={{
                                        backgroundColor:
                                          i % 2 !== 0 ? "black" : "white",
                                      }}
                                    ></div>
                                  ))}
                                </div>
                              );
                            })()}
                            {dynamicScale.ticks.map((tick, index) => {
                              const N = Math.max(
                                1,
                                (dynamicScale.ticks?.length || 1) - 1
                              );
                              const left = (index / N) * 100;
                              return (
                                <div
                                  key={index}
                                  style={{
                                    position: "absolute",
                                    top: "-.8rem",
                                    left: `${left}%`,
                                    transform: "translateX(-50%)",
                                    fontSize: "6pt",
                                  }}
                                >
                                  {tick.split(" ")[0]}
                                </div>
                              );
                            })}
                            <div
                              style={{
                                position: "absolute",
                                top: ".8rem",
                                right: 0,
                                fontSize: "8pt",
                              }}
                            >
                              {dynamicScale.ticks[0].split(" ")[1]}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* BOX 5 */}
                    <div className="dsda-inset-container">
                      <table className="dsda-map-format-title">
                        <tbody>
                          <tr>
                            <td>Proyeksi</td>
                            <td>:</td>
                            <td>Universal Transverse Mercator</td>
                          </tr>
                          <tr>
                            <td>Sistem Grid</td>
                            <td>:</td>
                            <td>
                              Grid Geografi dan Grid Universal Transverse
                              Mercator
                            </td>
                          </tr>
                          <tr>
                            <td>Datum Horizontal</td>
                            <td>:</td>
                            <td>WGS 84 - Zone 48S</td>
                          </tr>
                        </tbody>
                      </table>
                      {/* Inset Map */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "100%",
                          alignItems: "center",
                        }}
                      >
                        <p className="dsda-inset-title">INSET</p>
                        <div className="dsda-inset-map-ref">
                          {generateGraticuleLabel(
                            graticuleLabel.inset.x,
                            "bottom",
                            "inset"
                          )}
                          {generateGraticuleLabel(
                            graticuleLabel.inset.y,
                            "left",
                            "inset"
                          )}
                          <div
                            ref={insetMapRef}
                            style={{
                              width: "100%",
                              height: "100%",
                              position: "relative",
                            }}
                          >
                            <canvas
                              ref={insetCanvasRef}
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                pointerEvents: "none",
                                zIndex: 10,
                              }}
                            ></canvas>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* BOX 6 */}
                    <div className="dsda-legend-container">
                      {/* KETERANGAN */}
                      <div className="dsda-legend-title">Keterangan :</div>
                      <div
                        style={{
                          display: "grid",
                          gridTemplateRows: "repeat(3, 1fr)",
                          gridAutoFlow: "column",
                          gap: ".15rem",
                        }}
                      >
                        {legends?.map((item, index) => (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              gap: "5px",
                              alignItems: "start",
                              maxWidth: "120px",
                            }}
                          >
                            <div
                              className="dsda-legend-icon"
                              style={{ backgroundColor: item[1] }}
                            />
                            <div>{item[0]}</div>
                          </div>
                        ))}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "5px",
                            alignItems: "start",
                            maxWidth: "100px",
                          }}
                        >
                          <img
                            src={waduk_icon}
                            className="dsda-legend-icon-png"
                            alt="icon waduk situ embung"
                          />
                          <div>Waduk Situ Embung</div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "5px",
                            alignItems: "start",
                            maxWidth: "120px",
                          }}
                        >
                          <img
                            src={drainase_primer_icon}
                            className="dsda-legend-icon-png"
                            alt="icon saluran drainase primer"
                          />
                          <div>Saluran Drainase Primer</div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "5px",
                            alignItems: "start",
                            maxWidth: "120px",
                          }}
                        >
                          <img
                            src={drainase_sekunder_icon}
                            className="dsda-legend-icon-png"
                            alt="icon saluran drainase sekunder"
                          />
                          <div>Saluran Drainase Sekunder</div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "5px",
                            alignItems: "start",
                            maxWidth: "120px",
                          }}
                        >
                          <img
                            src={drainase_tersier_icon}
                            className="dsda-legend-icon-png"
                            alt="icon saluran drainase tersier"
                          />
                          <div>Saluran Drainase Tersier</div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "5px",
                            alignItems: "start",
                            maxWidth: "120px",
                          }}
                        >
                          <img
                            src={batas_kelurahan}
                            className="dsda-legend-icon-png"
                            alt="icon batas kelurahan"
                          />
                          <div>Batas Kelurahan</div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "5px",
                            alignItems: "start",
                            maxWidth: "120px",
                          }}
                        >
                          <img
                            src={batas_kabupaten_kota}
                            className="dsda-legend-icon-png"
                            alt="icon batas kabupaten/kota"
                          />
                          <div>Batas Kabupaten/Kota</div>
                        </div>
                      </div>
                    </div>

                    {/* BOX 7 */}
                    <div className="dsda-data-source-container">
                      <div>Sumber Data :</div>
                      <ol>
                        <li>
                          Data Sungai/Kali Dinas Sumber Daya Air Provinsi DKI
                          Jakarta
                        </li>
                        <li>
                          Data Genangan berdasarkan Aplikasi Laporan Genangan
                          DSDA
                        </li>
                        <li>
                          Data Curah Hujan Dinas Sumber Daya Air Provinsi DKI
                          Jakarta
                        </li>
                      </ol>
                    </div>
                  </div>
                </section>
              </div>

              {/* Close Modal Button */}
              <button
                onClick={() => {
                  setIsModal(false);
                }}
                className="close_sidebar_left background_black outline_white"
                style={{
                  position: "absolute",
                  top: ".5rem",
                  right: ".5rem",
                }}
              >
                <ICON_CLOSE_X_2
                  color="#fff"
                  style={{
                    width: "15px",
                  }}
                />
              </button>

              {/* Export PDF Button */}
              <div
                style={{
                  position: "absolute",
                  right: "1rem",
                  bottom: "1rem",
                  display: "flex",
                  flexDirection: "row",
                  gap: "1rem",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <div
                    style={{
                      fontSize: ".85rem",
                      fontWeight: "bold",
                      textWrap: "nowrap",
                    }}
                  >
                    Ukuran Kertas
                  </div>
                  <div>:</div>
                  <div
                    style={{
                      fontWeight: 200,
                      border: "2px solid #cbd1d8",
                      borderRadius: "9px",
                      padding: "5px",
                      fontSize: ".75rem",
                    }}
                  >
                    {paperSize.size.toUpperCase()}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <div style={{ fontSize: ".85rem", fontWeight: "bold" }}>
                    Skala
                  </div>
                  <div>:</div>
                  <input
                    type="number"
                    style={{
                      resize: "none",
                      padding: "5px",
                      margin: "0",
                      paddingInline: "5px",
                      paddingBlock: "5px",
                      minHeight: "12px",
                      height: "auto",
                      fontSize: ".75rem",
                    }}
                    value={pendingScale}
                    onChange={(e) => {
                      setPendingScale(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        const n = Number(pendingScale.replaceAll(",", ""));
                        if (!Number.isFinite(n) || n <= 0) return;

                        setIsUserInputScale(true);
                        setScale(n);

                        if (mainMap) {
                          const newZoom = generateScaleToZoom(mainMap, n, 96);
                          if (!Number.isNaN(newZoom)) {
                            mainMap.setZoom(newZoom);
                          }
                        }
                      }
                      if (e.key === "Escape")
                        setPendingScale(scale ? String(scale) : "");
                    }}
                  />
                </div>
                <button
                  onClick={handleExportPDF}
                  className="button background_black"
                >
                  Export PDF
                </button>
              </div>
            </div>
          </div>,
          document.body
        )
      ) : (
        <></>
      )}
      <button
        onClick={() => {
          setIsModal(true);
        }}
        title="EKSPOR PETA"
        className="button_download_data"
      >
        <img src={logo_export_map} width={40} alt="icon expor peta" />
        <p>Peta</p>
      </button>
    </>
  );
}
